export const NO_CONFLICT = 'NO_CONFLICT'
export const CONFLICTS_OVER_VIEW = 'CONFLICTS_OVER_VIEW'
export const CONFLICTS_DIGITAL_INPUT_VIEW = 'CONFLICTS_DIGITAL_INPUT_VIEW'
export const CONFLICTS_ANALOG_INPUT_VIEW = 'CONFLICTS_ANALOG_INPUT_VIEW'
export const CONFLICTS_DIGITAL_OUTPUT_VIEW = 'CONFLICTS_DIGITAL_OUTPUT_VIEW'
export const CONFLICTS_SWITCHES_WITH_SHARED_SIGNALS_VIEW =
  'CONFLICTS_SWITCHES_WITH_SHARED_SIGNALS_VIEW'
export const CONFLICTS_CAN_OUTPUT_VIEW = 'CONFLICTS_CAN_OUTPUT_VIEW'
export const CONFLICTS_TABLE_VIEWS = {
  digitalInput: CONFLICTS_DIGITAL_INPUT_VIEW,
  analogInput: CONFLICTS_ANALOG_INPUT_VIEW,
  digitalOutput: CONFLICTS_DIGITAL_OUTPUT_VIEW,
  canOutput: CONFLICTS_CAN_OUTPUT_VIEW,
}
export const MAX_NUMBER_LOGICS = 40
export const MAX_NUMBER_TIMERS = 20
